import { render, staticRenderFns } from "./StockProductMovements.vue?vue&type=template&id=4b1bf0c1"
import script from "./StockProductMovements.vue?vue&type=script&lang=js"
export * from "./StockProductMovements.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports